<template>
  <div
    class="index-use"
    :style="{
      'background': 'url('+ element.commonStyle.backgroundImage +') no-repeat center center',
      'background-size': '100% 100%'
    }"
  >
    <div class="iphone-activity-tap">
      <h2
        class="iphone-activity-title"
        style="line-height: 0.56rem"
        v-if="element.titleBarName"
      >{{ element.titleBarName }}</h2>
      <h3 v-if="element.titleBarDesc">{{ element.titleBarDesc }}</h3>
      <div class="active-swiper">
        <ul
          v-if="childItem.propsValue.data.length > 0 && childItem.propsValue.data[0].customField1"
          class="swiper-pagination"
        >
          <h3
            v-for="(item, index) in childItem.propsValue.data"
            :key="index"
            :class="index == 0 ? 'swiper-pagination-bullet swiper-pagination-bullet-active' : 'swiper-pagination-bullet'"
          >{{ item.customField1 }}</h3>
        </ul>
        <div v-if="childItem.propsValue.data.length > 0">
          <h3
            v-if="childItem.propsValue.data[0].customField2"
            style="margin-bottom: 15px;"
          >{{ childItem.propsValue.data[0].customField2 }}</h3>
          <img
            v-if="childItem.propsValue.data[0].customField3"
            :src="childItem.propsValue.data[0].customField3"
            width="100%"
          />
        </div>
      </div>
    </div>
    <a class="index-btn" style="margin: 0 auto">
      {{
      childItem.propsValue.buttonInfo.text
      }}
    </a>
  </div>
</template>

<script>
// 应用场景-移动端
export default {
  name: "MkYingyongchangjingPhone",
  props: {
    element: {
      type: Object,
      default: () => {
        return {};
      }
    },
    childItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      fields: [
        {
          code: "customField1",
          label: "标题",
          type: "text"
        },
        {
          code: "customField2",
          label: "描述",
          type: "text"
        },
        {
          code: "customField3",
          label: "图片",
          type: "image",
          width: 690,
          height: 640
        }
      ],
      buttonInfo: {
        text: "获取数智化解决方案",
        beforeClick: {
          type: 0, // 0 直接访问使用， 1 填写表单后有效
          form: "", // 表单ID，按钮点击需填写表单
          formtime: "无" // 表单有效期  无 一天 七天 永久
        },
        afterClick: {
          type: 1, // 点击后类型  0 无跳转，1 跳转页面  2 关联内容
          url: "",
          contentType: "data", // data 资料， article 文章， video 视频
          contentId: ""
        }
      },
      data: [
        {
          customField1: "发票管理",
          customField2: "",
          customField3: ""
        },
        {
          customField1: "计税申报",
          customField2: "",
          customField3: ""
        },
        {
          customField1: "风控分析",
          customField2: "",
          customField3: ""
        },
        {
          customField1: "知识管理",
          customField2: "",
          customField3: ""
        }
      ]
    };
  }
};
</script>

<style scoped lang="scss">
/* 典型应用场景 */
.index-use {
  padding-bottom: 10px;
  background: #fff;
  .index-btn {
    display: block;
    width: 180px;
    height: 32px;
    line-height: 32px;
    color: #ffffff;
    font-size: 12px;
    text-align: center;
    background-image: linear-gradient(135deg, #e97528 0%, #e90713 52%);
    border-radius: 3[x];
  }
  .iphone-activity-title {
    text-align: center;
    color: #e31924;
    line-height: 1.5;
    font-size: 20px;
    font-weight: bold;
  }
  .iphone-activity-tap {
    padding-top: 0.6rem;
    position: relative;
    text-align: center;
    h3 {
      font-weight: normal;
      margin-top: 8px;
    }
    > p {
      font-size: 12px;
      color: #727272;
    }
    .active-swiper {
      position: relative;
      padding-top: 23px;
      overflow: hidden;
      .swiper-pagination {
        margin-bottom: 10px;
        box-sizing: border-box;
        width: 100%;
        top: 17px;
        display: flex;
        h3 {
          background: none;
          color: #707070;
          width: 20%;
          font-size: 12px;
          padding-bottom: 17px;
          position: relative;
          opacity: 1;
          margin: 0;
          font-weight: 400;
        }
        h3::before {
          content: " ";
          position: absolute;
          width: 60%;
          background: #e31924;
          height: 2px;
          bottom: 0;
          display: none;
          border-radius: 3px;
          left: 50%;
          transform: translateX(-50%);
        }
        .swiper-pagination-bullet-active:before {
          display: block;
        }
        .swiper-pagination-bullet-active {
          color: #e31924;
          font-weight: 600;
          position: relative;
        }
      }
    }
  }
}
</style>
